import React from "react";
import { ImageProvider } from "../../../utils/image-provider";
import Markdown from "react-markdown";
import { Link } from "gatsby";
const ExploreSection = ({ data }) => {
  if (!data) return null;

  const {
    heading,
    heading_color,
    sub_heading,
    description,
    desktop_bg,
    mobile_bg,
    button,
  } = data;

  return (
    // <div className="relative w-full h-[110vw] xl:w-[100%] xl:h-[66vh] px-[5%] xl:px-0 flex items-center m-auto justify-center xl:justify-start overflow-hidden">
    //   {/* Responsive background image */}
    //   <ImageProvider
    //     Image={desktop_bg}
    //     alt={desktop_bg?.alternativeText || "Image"}
    //     tailwindStyle={`absolute inset-0 left-1/2 -translate-x-1/2 w-[90vw] h-[102vw] xl:w-[100%] xl:h-[100%] rounded-[2vh] xl:rounded-none object-cover xl:object-contain z-0`}
    //   />
    //   {/* Inner content */}
    //   <div className="relative z-20 px-[2vh] xl:px-[12vh] py-[0vh] xl:py-[4vh] flex flex-col items-start gap-[2vh] xl:gap-[4vh] xl:text-left justify-center xl:pl-[13vh] xl:w-2/3">
    //     {/* Heading */}
    //     <h1
    //       className="text-[6vh] xl:text-[15vh] font-bold"
    //       style={{ color: heading_color }}
    //     >
    //       {heading}
    //     </h1>
    //     {/* Sub Heading */}
    //     <div
    //       className="text-[3vh] xl:text-[6vh] font-normal"
    //       style={{ color: "#fff" }}
    //     >
    //       {sub_heading}

    //       {/* Description */}
    //       {description?.data?.description && (
    //         <div
    //           className="text-[1.8vh] xl:text-[3vh] font-normal"
    //           style={{ color: "#fff" }}
    //         >
    //           {description.data.description}
    //         </div>
    //       )}
    //     </div>
    //     {/* Button */}
    //     {button && (
    //       <a
    //         href={button.href}
    //         target={button.target}
    //         rel={button.target === "_blank" ? "noopener noreferrer" : undefined}
    //         className=" rounded-[1vh] xl:rounded-[1.5vh] px-[2vh] xl:px-[5vh] py-[0.7vh] xl:py-[1vh] text-[2vh] xl:text-[3.6vh] w-[100%] xl:w-auto text-center font-normal"
    //         style={{
    //           backgroundColor: button.bg_color || "#fff",
    //           color: button.label_color || "#002C61",
    //         }}
    //       >
    //         {button.label}
    //       </a>
    //     )}
    //   </div>
    // </div>
    <div>
      <div
        style={{
          backgroundImage: `url(${desktop_bg?.url})`,
          backgroundSize: "100% auto",
          backgroundRepeat: "no-repeat",
        }}
        className="lg:block py-[1vw] hidden"
      >
        <div className="container">
          <h1 className="text-white lg:text-[5vw] font-redhatBold">
            {heading}
          </h1>
          <h2 className="text-white lg:text-[3.5vw] font-redhatRegular">
            {sub_heading}
          </h2>
          <div className="text-white lg:w-[40%] lg:text-[1.7vw] lg:pr-[1vw] font-redhatRegular">
            <Markdown>{description?.data?.description}</Markdown>
          </div>
          <div className="flex justify-start items-center lg:py-[2vw]">
            <Link
              to={button?.href}
              className="lg:px-[3vw] py-[0.5vw] lg:text-[1.6vw] lg:rounded-[0.5vw] 
               focus:outline focus:outline-2 focus:outline-white focus:outline-offset-4 inline-block"
              style={{
                backgroundColor: button.bg_color || "#fff",
                color: button.label_color || "#002C61",
              }}
            >
              {button?.label}
            </Link>
          </div>
        </div>
      </div>
      <div className="lg:hidden block container px-[2vw]">
        <div
          style={{
            backgroundImage: `url(${mobile_bg?.url})`,
            backgroundSize: "100% auto",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="container pl-[3vw] py-[6vw]">
            <h1 className="text-white text-[12vw] font-redhatBold">
              {heading}
            </h1>
            <h2 className="text-white text-[7vw] font-redhatRegular leading-tight">
              {sub_heading}
            </h2>
            <div className="text-white w-[90%] py-[3vw] text-[4.5vw] font-redhatRegular leading-tight">
              <Markdown>{description?.data?.description}</Markdown>
            </div>
            <Link to={button?.href}>
              <div className="flex justify-start items-center pt-[2vw] pb-[22vw]">
                <button
                  className="w-[95%] py-[1vw] bg-white rounded-[3vw] text-[5vw]"
                  style={{
                    backgroundColor: button.bg_color || "#fff",
                    color: button.label_color || "#002C61",
                  }}
                >
                  {button?.label}
                </button>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExploreSection;
